import { render, staticRenderFns } from "./EventTypeFieldForm.vue?vue&type=template&id=798891bb"
import script from "./EventTypeFieldForm.vue?vue&type=script&lang=js"
export * from "./EventTypeFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports